import { apiClient } from './client';
import { unwrapList, unwrapMeta } from '../utils/api';

/**
 * Support inbox API — staff/admin endpoints.
 */

/** GET /support/admin/tickets — one page: { data, meta: { total, page, limit, totalPages } } */
export async function getAdminTickets(params = {}) {
  const { data } = await apiClient.get('/support/admin/tickets', { params });
  return { data: unwrapList(data), meta: unwrapMeta(data) };
}

/**
 * GET /support/admin/tickets/stats
 * { open, inProgress, waitingUser, resolved (all-time), resolvedToday, closed, unassigned,
 *   avgFirstResponseMinutes, createdLast7Days }
 */
export async function getAdminTicketStats() {
  const { data } = await apiClient.get('/support/admin/tickets/stats');
  return data;
}

/** GET /support/admin/tickets/:id */
export async function getAdminTicket(id) {
  const { data } = await apiClient.get(`/support/admin/tickets/${id}`);
  return data;
}

/** PATCH /support/admin/tickets/:id */
export async function updateAdminTicket(id, body) {
  const { data } = await apiClient.patch(`/support/admin/tickets/${id}`, body);
  return data;
}

/** POST /support/admin/tickets/:id/messages */
export async function postAdminMessage(id, body) {
  const { data } = await apiClient.post(`/support/admin/tickets/${id}/messages`, body);
  return data;
}

/** GET /support/admin/agents */
export async function getAdminAgents() {
  const { data } = await apiClient.get('/support/admin/agents');
  return Array.isArray(data) ? data : unwrapList(data);
}
